{
  "Accessibility Menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು",
  "Reset settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
  "Close": "ಮುಚ್ಚಿ",
  "Content Adjustments": "ವಿಷಯದ ಹೊಂದಾಣಿಕೆಗಳು",
  "Adjust Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸಿ",
  "Highlight Title": "ಶೀರ್ಷಿಕೆಯನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Highlight Links": "ಲಿಂಕ್‌ಗಳನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Readable Font": "ಓದಲು ಸುಲಭವಾದ ಅಕ್ಷರಶೈಲಿ",
  "Color Adjustments": "ಬಣ್ಣ ಹೊಂದಾಣಿಕೆಗಳು",
  "Dark Contrast": "ಕತ್ತಲೆ ವ್ಯತ್ಯಾಸ",
  "Light Contrast": "ಹಗುರ ವ್ಯತ್ಯಾಸ",
  "High Contrast": "ಹೆಚ್ಚು ವ್ಯತ್ಯಾಸ",
  "High Saturation": "ಹೆಚ್ಚು ಸಾತುರ್ನತೆ",
  "Low Saturation": "ಕಡಿಮೆ ಸಾತುರ್ನತೆ",
  "Monochrome": "ಏಕವರ್ಣ",
  "Tools": "ಉಪಕರಣಗಳು",
  "Reading Guide": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ",
  "Stop Animations": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ",
  "Big Cursor": "ದೊಡ್ಡ ಕರ್ಸರ್",
  "Increase Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೆಚ್ಚಿಸಿ",
  "Decrease Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಕಡಿಮೆ ಮಾಡಿ",
  "Letter Spacing": "ಅಕ್ಷರಗಳ ನಡುವಿನ ಅಂತರ",
  "Line Height": "ಸಾಲಿನ ಎತ್ತರ",
  "Font Weight": "ಅಕ್ಷರದ ತೂಕ",
  "Dyslexia Font": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಅಕ್ಷರಶೈಲಿ",
  "Language": "ಭಾಷೆ",
  "Open Accessibility Menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು ಅನ್ನು ತೆರೆಯಿರಿ",
  "Accessibility Profiles": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಪ್ರೊಫೈಲ್‌ಗಳು",
  "Seizure Safe Profile": "ಏಕಾಘಾತ ಸುರಕ್ಷಿತ ಪ್ರೊಫೈಲ್",
  "Stops animations and reduces color saturation.": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸುತ್ತದೆ ಮತ್ತು ಬಣ್ಣದ ಸ್ಯಾಚುರೇಶನ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
  "Blind Profile": "ಅಂಧರುಗಳಿಗೆ ಪ್ರೊಫೈಲ್",
  "Activates the screen reader for auditory navigation.": "ಶ್ರವಣ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಸ್ಕ್ರೀನ್ ರೀಡರ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತದೆ.",
  "Visually Impaired Profile": "ದೃಷ್ಟಿಹೀನರಿಗೆ ಪ್ರೊಫೈಲ್",
  "Enhances contrast and readability for low vision.": "ಕಡಿಮೆ ದೃಷ್ಟಿಗೆ ವಿರುದ್ಧತೆ ಮತ್ತು ಓದುವ ಸಾಮರ್ಥ್ಯವನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.",
  "ADHD Friendly Profile": "ADHD ಗೆ ಅನುಕೂಲವಾದ ಪ್ರೊಫೈಲ್",
  "Reduces distractions for better focus.": "ಉತ್ತಮ ಗಮನಕ್ಕಾಗಿ ವ್ಯತ್ಯಯಗಳನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
  "Cognitive & Learning Profile": "ಜ್ಞಾನಾತ್ಮಕ ಮತ್ತು ಅಧ್ಯಯನ ಪ್ರೊಫೈಲ್",
  "Helpful tools for reading and comprehension.": "ಓದು ಮತ್ತು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಸಹಾಯಕ ಸಾಧನಗಳು.",
  "Motor Impaired Profile": "ಮೋಟಾರ್ ಸಾಮರ್ಥ್ಯ ಕೊರತೆಯವರ ಪ್ರೊಫೈಲ್",
  "Optimizes the site for keyboard-only navigation.": "ಕೈಬೋರ್ಡ್ ಮಾತ್ರ ಬಳಸಿ ನಾವಿಗೇಶನ್ ಮಾಡಲು ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಸುಧಾರಿಸುತ್ತದೆ.",
  "Headings": "ಶೀರ್ಷಿಕೆಗಳು",
  "Landmarks": "ಲ್ಯಾಂಡ್‌ಮಾರ್ಕ್‌ಗಳು",
  "Links": "ಲಿಂಕ್‌ಗಳು",
  "Focus element": "ಫೋಕಸ್ ಘಟಕ",
  "Visit link": "ಲಿಂಕ್‌ಗೆ ಭೇಟಿ ನೀಡಿ"
}